<template>
  <div class="container">
    <div class="logo c-pointer" @click="$router.push({name:'home'})">
      <img :src="require('@/assets/images/icon_logo.png')" alt="">
    </div>
    <div class=" bread-crumb-container">
      您现在的位置：
       <el-breadcrumb separator-class="el-icon-arrow-right">
           <el-breadcrumb-item v-for="item in list"  :to="{path:item.path}">{{item.name}}</el-breadcrumb-item>
           <el-breadcrumb-item v-if=" $route.name == 'pay'">支付</el-breadcrumb-item>
           
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      list:[
        {name:'首页',path:'/'},
         {name:'购物车',path:'/cart/cartlist'},
      ]
    }
  },
  methods: {

  },
  watch:{

  }
  
}
</script>
<style lang="scss" scoped>
.container{
  margin-bottom: 20px;
  color: #808080;
}
  .logo{
    margin-top: 30px;
    margin-bottom: 20px;
  }
    .bread-crumb-container{
    color: #808080;
    font-size: 13px;
    margin: 18px auto;
    display: flex;
    /deep/ .el-breadcrumb__inner{
      font-size: 13px !important;
      color: #808080 !important;
    } 
  }
  .order{
    font-weight: 700;
  }
    /deep/ .el-breadcrumb__inner a,  /deep/ .el-breadcrumb__inner.is-link{
    font-weight: 400;
  }
</style>


// WEBPACK FOOTER //
// src/pages/cart/components/cart-top.vue